import { logout } from "./../store/modules/user/actions";
import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
  ServerError,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { BASE_API_URL } from "./../config";
import { store } from "./../index";
import { onError } from "@apollo/client/link/error";

const cache = new InMemoryCache();

const httpLink = createHttpLink({
  uri: `${BASE_API_URL}/v1/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const {
    user: { authToken },
  } = store.getState();

  return {
    headers: {
      ...headers,
      Authorization: authToken ? `Bearer ${authToken}` : "",
    },
  };
});

const logoutLink = onError(({ networkError }) => {
  if (
    networkError &&
    (networkError as ServerError).statusCode &&
    (networkError as ServerError).statusCode === 401
  )
    store.dispatch(logout());
});

const link = ApolloLink.from([logoutLink, authLink, httpLink]);

export const client = new ApolloClient({
  cache: cache,
  link,
});
